/**
 * @file queue-task.tsx
 * @description Специализированная форма фильтрации для задач очереди в Task Manager приложении, которая обеспечивает фильтрацию данных очереди задач по специфическим критериям. Отображает только те поля фильтров, которые относятся к табу 'filters', используя утилиту getFieldByName для автоматической генерации соответствующих полей формы на основе конфигурации фильтров и их типов.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-16
 * @dependencies ['@features/filter/helper']
 * @related-files ['src/features/filter/components/table-modal/table-modal.component.tsx', 'src/features/queue/queue.component.tsx', 'src/features/filter/helper.ts']
 */

import { getFieldByName } from '@features/filter/helper';

export const QueueTaskFilterForm = ({ control, filters }: any) => {
    return (
        <div className="flex flex-col gap-default w-[35.4611vmin]">
            {filters
                .filter((filter: any) => filter.tab === 'filters')
                .map((item: any, key: number) => getFieldByName(filters, control, item.name, { key }))}
        </div>
    );
};